export default "__VITE_ASSET__a237b82a__"